import React from 'react';
import { createUseStyles } from 'react-jss';
import { AiSparkleIcon } from './icons/AiSparkleIcon';

const useStyles = createUseStyles({
    askAiContainer: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '0px 30px 0px 10px',
        borderRadius: '4px',
        color: '#1677ff',
        justifyContent: 'right',
    },
    askAiIcon: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        color: '#1677ff',
    },
    askAiText: {
        color: '#1677ff',
        fontWeight: 500,
        fontSize: '14px',
    },
});

interface AskAiButtonProps {
    onClick: () => void;
}

export const AskAiButton: React.FC<AskAiButtonProps> = ({ onClick }) => {
    const classes = useStyles();

    return (
        <div className={classes.askAiContainer} onClick={onClick}>
            <div className={classes.askAiIcon}>
                <AiSparkleIcon />
            </div>
            <div className={classes.askAiText}>
                Ask AI
            </div>
        </div>
    );
};